import MatchColorObject from "../../components/Nursery/GeneralAwareness/MatchColorObject";
import PickRandomColor from "../../components/Nursery/GeneralAwareness/PickRandomColor";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


document.title = "Mamas Guidance - Nursery - General Awareness - Colors"; // Set page title


const topics: MenuItem[] = [
    { url: "/nursery/general-awareness/colors/pick-color", title: "Pick Color", component: PickRandomColor},
    { url: "/nursery/general-awareness/colors/match-color", title: "Match Same Color", component: MatchColorObject},
];


export default topics;